import { EpicIcons, Icon, Tooltip, TooltipPosition } from "@constellation-academy/epic-ui";
import { useTranslation } from "@i18n/hooks";
import { helpIconClass, helpListClass, helpTextClass } from "./s3-video-source-field.styles";

const HelpIconId = "s3-folder-help";

export const S3FolderHelp = () => {
	const { t } = useTranslation("common");

	return (
		<>
			<Tooltip target={`#${HelpIconId}`} position={TooltipPosition.Bottom}>
				<div className={helpTextClass}>
					<p>{t("educationalOffer.s3FolderHelpPath")}</p>
					<p>{t("educationalOffer.s3FolderHelpContains")}</p>
					<ul className={helpListClass}>
						<li>{t("educationalOffer.s3FolderHelpVideo")}</li>
						<li>{t("educationalOffer.s3FolderHelpSubtitles")}</li>
					</ul>
					<p>{t("educationalOffer.s3FolderHelpBrokenSubtitles")}</p>
				</div>
			</Tooltip>
			<span
				id={HelpIconId}
				className={helpIconClass}
				tabIndex={0}
				role="img"
				aria-label={t("educationalOffer.s3FolderHelpLabel")}
			>
				<Icon icon={EpicIcons.INFO_CIRCLE} />
			</span>
		</>
	);
};
